// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2KRXq","range":"MonthRangeSwitch_range__39qvb","disabled":"MonthRangeSwitch_disabled__1avbW"};